export default __webpack_public_path__ + "static/media/rate.04c38699.less";